import * as React from "react";
import get from "lodash/get";

import "./EarnPoints.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface EarnPointsProps extends ComponentBaseProps {
  descriptionStyle?: React.CSSProperties;
  pointsStyle?: React.CSSProperties;
  dividerStyle?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
  align?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
}

export class EarnPoints extends ComponentBase<EarnPointsProps> {
  render() {
    const { classNames, descriptionStyle, pointsStyle, dividerStyle, style } =
      this.props;

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        className={`EarnPoints-container ${classNames || ""}`}
        style={{ ...style, maxHeight: get(style, "height", "inherit") }}
        aria-label="Earn Points!"
        ref={(component) => (this.component = component)}
      >
        {exampleActivities.map((activity) => {
          return (
            <React.Fragment key={activity.name}>
              <div className="EarnPoints-item">
                <div tabIndex={0} style={descriptionStyle}>
                  {activity.description}
                </div>
                <div tabIndex={0} style={pointsStyle}>
                  {activity.points}
                </div>
              </div>
              <div className="EarnPoints-divider" style={dividerStyle} />
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

const exampleActivities = [
  {
    description: "Refer a Friend",
    icon: "referral",
    name: "referral",
    points: "50",
    status: "completed",
  },

  {
    description: "Like us on Facebook",
    icon: "facebookLike",
    name: "facebook_like",
    points: "10",
    status: "completed",
  },
  {
    description: "Share us on Facebook",
    icon: "facebookShare",
    name: "facebook_share",
    points: "20",
    status: "pending",
  },
  {
    description: "Get 2x points on your anniversary",
    icon: "anniversary",
    name: "anniversary",
    points: "2",
    status: "completed",
  },
  {
    description: "Like us on Instagram",
    icon: "instagram",
    name: "instagram_like",
    points: "10",
    status: "pending",
  },
  {
    description: "Subscribe to our newsletter",
    icon: "email",
    name: "newsletter_subscribe",
    points: "5",
    status: "pending",
  },
];
